import { render, staticRenderFns } from "./GanttItemForm.vue?vue&type=template&id=aef42824&"
import script from "./GanttItemForm.vue?vue&type=script&lang=js&"
export * from "./GanttItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports